
import AnimatedSection from '../../../components/base/AnimatedSection';

export default function ComoSeDa() {
  const items = [
    { icon: "ri-map-pin-line", title: "Presencial" },
    { icon: "ri-hand-heart-line", title: "Práctico" },
    { icon: "ri-footprint-line", title: "Paso a paso" },
    { icon: "ri-edit-box-line", title: "Ejercicios guiados" },
    { icon: "ri-file-copy-line", title: "Plantillas para copiar y adaptar" },
    { icon: "ri-computer-line", title: "Traer notebook para practicar" },
  ];

  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <AnimatedSection animation="fadeUp">
            <h2 className="text-4xl md:text-5xl font-bold mb-12">
              Cómo se da el curso
            </h2>
          </AnimatedSection>
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {items.map((item, index) => (
              <AnimatedSection key={item.title} animation="scaleUp" delay={index * 80}>
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10 h-full">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-full mb-4 mx-auto">
                    <i className={`${item.icon} text-3xl text-white`} />
                  </div>
                  <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
